import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from '@/context/AuthContext';
import { WebsiteProvider } from '@/context/WebsiteContext';
import { PostHogProvider } from '@posthog/react';
import './index.css';

const posthogOptions = {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2026-01-30',
} as const;

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={posthogOptions}>
            <AuthProvider>
                <WebsiteProvider>
                    <App />
                </WebsiteProvider>
            </AuthProvider>
        </PostHogProvider>
    </React.StrictMode>,
);
